<template>
  <div class="row">
   
    <div v-if="!programa" class="flex md12 xs12 lg3 scroll2">
      <va-card class>
        <p class="display-3 text-center">{{$t('arealuno.Modulos')}}</p>
        <hr />
        <div
          v-for="(lista_disciplinas,index) in getAllMateriasCurso"
          :key="index"
          class="tamanho_avisos display-5 my-2 text-center"
        >
          <va-button
            type="submit"
            @click="mudar_disciplina(lista_disciplinas)"
            color="info"
            class="display-3 text-center"
          >{{lista_disciplinas.nome_disciplina}}</va-button>
        </div>
      </va-card>
    </div>
    <div class="flex md12 xs12 lg4">
      <va-card class="tamanho_avisoa">
        <div>
          <p class="display-3 text-center">{{$t('arealuno.Bemvindos')}}</p>
        </div>
        <hr />

        <va-card class="tamanho_avisos display-5 my-2 text-center">
          <p display-3 text-center>{{disciplina.nome}}</p>
        </va-card>

      <div class="row flex">
      <va-button
        type="submit"
        @click="programa = true"
        color="info"
        class="display-3 text-center"
      >Calendario académico
      </va-button>
    
    </div>

    <div v-if="programa" class="row flex">
        <va-button
        @click="programa = false"
        color="primary"
        class="display-3 text-center"
      >Volver</va-button>
    </div>
        
      
      </va-card>
    </div>
    <div v-if="programa" class="flex md12 xs12 lg5 tamanho_avisoa">
      <modalprograma ></modalprograma>
     
    </div>
    <div v-if="!programa" class="flex md12 xs12 lg5 tamanho_avisoa">
      <va-card  class="scroll">
        <div>
          <p class="display-3 text-center">Avisos</p>
        </div>
        <hr />

        <chatrespostas v-model="avisos" />
      </va-card>
    </div>
 

    <!-- inicio calendario -->
    <div v-if="!programa" class="flex row">
      
      <div class="flex md12 xs12 lg7">
        <va-card>
          <!--  class="my-2" -->
          <div>
            
            <p class="display-3 text-center">{{$t('arealuno.Calendario')}}</p>
              
          </div>
         
          <hr />

          <va-data-table :fields="getlista" :data="getCalendarioMateria" hoverable no-pagination>
            <template slot="marker" slot-scope="props">
              <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
    <!-- fim calendario -->

     
  </div>
</template>

<script>
import chatrespostas from "./chatRespostas";
import modalprograma from './modalPrograma'

export default {
  components: { chatrespostas,modalprograma },
  data() {
    return {
      programa:false,
      disciplina: {
        id: "",
        nome: ""
      },
      videos: {
        id: this.$store.state.datamateria.setmateria.id,
        tipo_arquivo_id: 1
      },
      slides: {
        id: this.$store.state.datamateria.setmateria.id,
        tipo_arquivo_id: 2
      },
      audios: {
        id: this.$store.state.datamateria.setmateria.id,
        tipo_arquivo_id: 3
      },
      extras: {
        id: this.$store.state.datamateria.setmateria.id,
        tipo_arquivo_id: 5
      },

      avisos: []
    };
  },
  created() {
    this.all();
  },
  computed: {
    url_programa() {
     return this.$store.state.datamateria.datamateria.caminho
    },
    getAllMateriasCurso() {
      return this.$store.state.datamateria.datamateria;
    },

    allArquviosVideos() {
      return this.$store.state.arquivos.allArquivosVideos;
    },
    allArquviosSlides() {
      return this.$store.state.arquivos.allArquivosSlides;
    },
    allArquviosAudios() {
      return this.$store.state.arquivos.allArquivosAudios;
    },
    allArquviosExtras() {
      return this.$store.state.arquivos.allArquivosExtras;
    },

    getCalendarioMateria() {
      return this.$store.state.mensagens.setCalendarioAcademico;
    },

    getlista() {
      return [
        {
          name: "__slot:marker",
          width: "30px",
          dataClass: "text-center"
        },
        {
          name: "mensagem",
          title: this.$t("tables.headings.name")
        },
        {
          name: "data_inicio",
          //  dataClass: 'text-center',
          title: this.$t("arealuno.Data_inicio")
        },
        {
          name: "data_termino",
          // dataClass: 'text-center',
          title: this.$t("arealuno.Data_termino")
        }
      ];
    }
  },
  methods: {
    async all() {
      //  await  this.$store.dispatch('allArquivosPaginaInicial',this.videos )
      //  await this.$store.dispatch('allArquivosPaginaInicial',this.slides )
      //  await  this.$store.dispatch('allArquivosPaginaInicial',this.audios )
      //  await this.$store.dispatch('allArquivosPaginaInicial',this.extras )

      await this.$store.dispatch(
        "allDatamateria",
        this.$store.state.gradecurricular.dados_gradecurricular.id
      );
      this.disciplina = {
        id: this.$store.state.datamateria.setmateria.id,
        nome: this.$store.state.datamateria.setmateria.nome_disciplina
      };
      this.allAvisosDisciplina(this.disciplina.id);

      this.$store.dispatch(
        "allCalendariaAcademico",
        this.$store.state.datamateria.setmateria.id
      );
    },
    async allAvisosDisciplina(id) {
      await this.$store.dispatch("allAvisosDisciplina", id);
    },
    async mudar_disciplina(value) {
      await this.$store
        .dispatch("setMateria", value)
        // context.commit('SET_MATERIA',value)
        .then(() => {})
        .catch(() => {})
        .finally(() => this.all());
    },

    download_arquivo(value) {
      this.$store.dispatch("downloadArquivo", value);
    }
  }
};
</script>

<style lang="scss">
.tamanho {
  width: 100%;
}
.tamanho_avisos {
  width: 100%;
}
.tamanho_avisoa {
  min-height: 300px;
  max-height: 300px;
}

.scroll {
  overflow-y: scroll;
  max-height: 480px;
}
.scroll2 {
  overflow-y: scroll;
  max-height: 310px;
}
</style>